/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import IconOrgaoPublico from 'assets/images/icon_orgao_publico.svg';
import { MyHistoryState } from 'store/modules/my_history_store/types';
import ListItensOrgaos from 'components/atoms/list_itens_orgaos';
import Loader from 'components/atoms/loader';
import Pagination from 'components/atoms/pagination';

const OrgaosList = () => {
  const [BiddingInfoToggle, setBiddingInfoToggle] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { my_history, request } = useSelector<ApplicationState, MyHistoryState>(
    (state) => state.session.my_history,
  );

  const indexOfLastPost = currentPage * 10;
  const indexOfFirstPost = indexOfLastPost - 10;

  const currentPosts = my_history?.licitacoes_por_orgao?.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };
  return (
    <div className="card">
      <h6 className="card-title m-3 ml-2 font-weight-bold">
        <img className="mr-2" src={IconOrgaoPublico} width="20px" alt="Icone Orgão Público" />
        Órgão Público
      </h6>
      {request?.loading && <Loader />}
      {request?.loaded && (
        <div>
          <ListItensOrgaos listOrgaos={currentPosts} />
          <div className="border rounded-bottom border-top-0 d-print-none">
            <button
              type="button"
              key="btn-bidding-more-info"
              className="btn btn-sm btn-link m-0 w-100 mb-3"
              onClick={() => setBiddingInfoToggle(!BiddingInfoToggle)}
            >
              {BiddingInfoToggle ? 'Ver menos' : 'Ver mais'}
            </button>
            {BiddingInfoToggle && (
              <div className="row d-print-none">
                <div className="col-md-12 px-4 mb-5">
                  <Pagination
                    postsPerPage={10}
                    totalPosts={my_history?.licitacoes_por_orgao?.length}
                    paginate={paginate}
                    currentPage={currentPage}
                    firstAndLastPage
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrgaosList;
